<template>
  <div class="wechat-applyment-status-panel" :class="{ compact: compact }">
    <div class="status-grid">
      <div class="status-item">
        <span class="status-label">申请状态</span>
        <el-tag size="mini" :type="applymentStatus.type">{{ applymentStatus.text }}</el-tag>
      </div>
      <div class="status-item">
        <span class="status-label">商户确认</span>
        <el-tag size="mini" :type="confirmStatus.type">{{ confirmStatus.text }}</el-tag>
      </div>
      <div class="status-item">
        <span class="status-label">支付检查</span>
        <el-tag size="mini" :type="paymentStatus.type">{{ paymentStatus.text }}</el-tag>
      </div>
      <div class="status-item">
        <span class="status-label">分账接收方</span>
        <el-tag size="mini" :type="profitSharingStatus.type">{{ profitSharingStatus.text }}</el-tag>
      </div>
    </div>

    <el-alert
      v-if="rejectReason"
      class="status-alert"
      type="error"
      :closable="false"
      :title="rejectReason"
    />

    <div v-if="blockReason" class="block-reason">{{ blockReason }}</div>
  </div>
</template>
 
<script>
import { statusText } from "../utils/wechatApplymentForm";

const definedValue = (primary, fallback) =>
  primary === undefined || primary === null ? fallback : primary;

export default {
  name: "WechatApplymentStatusPanel",
  props: {
    applyment: {
      type: Object,
      default() {
        return {};
      },
    },
    profile: {
      type: Object,
      default() {
        return {};
      },
    },
    blockReason: {
      type: String,
      default: "",
    },
    compact: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    applymentData() {
      return this.applyment || {};
    },
    profileData() {
      return this.profile || {};
    },
    enabled() {
      return Number(this.profileData.is_enabled) === 1;
    },
    rejectReason() {
      return (
        this.applymentData.rejectReason ||
        this.applymentData.reject_reason ||
        this.profileData.rejectReason ||
        this.profileData.reject_reason ||
        ""
      );
    },
    readinessPassed() {
      const status = Number(
        definedValue(
          this.profileData.payment_ready_status,
          definedValue(this.profileData.readiness_status, 0)
        )
      );
      return status === 50 || status === 1;
    },
    applymentStatus() {
      const source = {
        status: definedValue(this.applymentData.status, this.profileData.applyment_status),
        is_enabled: this.profileData.is_enabled,
      };
      if (!this.enabled && Number(source.status) === 50 && this.readinessPassed) {
        return {
          text: "待标记可绑定",
          type: "warning",
        };
      }

      return {
        text: statusText(source),
        type: this.enabled ? "success" : "primary",
      };
    },
    confirmStatus() {
      const status = Number(
        definedValue(
          this.applymentData.account_confirm_status,
          definedValue(this.profileData.account_confirm_status, 0)
        )
      );
      if (this.enabled || status === 20 || status === 50) {
        return { text: "已确认", type: "success" };
      }

      if (status === 10 || status === 40) {
        return { text: "待确认", type: "danger" };
      }

      return { text: "无需确认", type: "warning" };
    },
    paymentStatus() {
      if (this.enabled) {
        return { text: "已启用", type: "success" };
      }

      if (this.readinessPassed) {
        return { text: "已就绪", type: "success" };
      }

      return { text: "待检查", type: "warning" };
    },
    profitSharingStatus() {
      if (Number(this.profileData.profit_sharing_status) === 50) {
        return { text: "已同步", type: "success" };
      }

      return { text: "待同步", type: "warning" };
    },
  },
};
</script>

<style lang="less" scoped>
.wechat-applyment-status-panel {
  padding: 14px 16px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  background: #fff;

  &.compact {
    padding: 8px 10px;

    .status-grid {
      row-gap: 6px;
    }

    .status-item {
      min-height: 24px;
    }

    .status-alert {
      margin-top: 8px;
    }

    .block-reason {
      margin-top: 6px;
    }
  }

  .status-grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(120px, 1fr));
    column-gap: 14px;
    row-gap: 10px;
  }

  .status-item {
    display: flex;
    align-items: center;
    min-height: 28px;
    color: #303133;
    font-size: 13px;
  }

  .status-label {
    margin-right: 8px;
    color: #333;
  }

  .status-alert {
    margin-top: 12px;
  }

  .block-reason {
    margin-top: 8px;
    color: #f56c6c;
    font-size: 12px;
    line-height: 18px;
  }
}
</style>
